/* DailyLama — en-tête et navigation V1.
 * Volets ordinateur (un seul ouvert, fermeture au clic extérieur, à Échap avec
 * retour du focus sur le déclencheur, et à la navigation) ; panneau mobile
 * unique à trois vues (principale, méga-menu à accordéons, menu simple), fond
 * figé, Échap, retour nommé « Menu ». Aucune dépendance. */
(function () {
  'use strict';

  var racine = document.querySelector('[data-dlnv]');
  if (!racine) return;
  var html = document.documentElement;
  var q = function (sel, ctx) { return (ctx || racine).querySelector(sel); };
  var qa = function (sel, ctx) { return [].slice.call((ctx || racine).querySelectorAll(sel)); };

  // ------------------------------------------------------------------ volets ordinateur
  var declencheurs = qa('[data-dlnv-declencheur]');
  var ouvert = null;

  function voletDe(cle) { return q('[data-dlnv-volet="' + cle + '"]'); }
  function fermerVolets(rendreFocus) {
    if (!ouvert) return;
    var d = ouvert;
    ouvert = null;
    declencheurs.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    qa('[data-dlnv-volet]').forEach(function (v) { v.hidden = true; });
    if (rendreFocus && d && typeof d.focus === 'function') d.focus();
  }
  function ouvrirVolet(bouton) {
    var cle = bouton.getAttribute('data-dlnv-declencheur');
    var volet = voletDe(cle);
    if (!volet) return;
    fermerVolets(false);
    ouvert = bouton;
    bouton.setAttribute('aria-expanded', 'true');
    volet.hidden = false;
  }
  declencheurs.forEach(function (b) {
    b.addEventListener('click', function () {
      if (ouvert === b) fermerVolets(false); else ouvrirVolet(b);
    });
  });
  document.addEventListener('pointerdown', function (e) {
    if (!ouvert) return;
    var barre = q('.dlnv-barre');
    if (barre && barre.contains(e.target)) return;
    fermerVolets(false);
  }, true);
  qa('.dlnv-volet a').forEach(function (a) { a.addEventListener('click', function () { fermerVolets(false); }); });

  // ------------------------------------------------------------------ panneau mobile
  var mobile = q('[data-dlnv-mobile]');
  var burger = q('[data-dlnv-ouvrir-mobile]');
  var panneau = mobile ? q('.dlnv-panneau', mobile) : null;
  var retour = mobile ? q('[data-dlnv-retour]', mobile) : null;
  var titre = mobile ? q('[data-dlnv-panneau-titre]', mobile) : null;
  var vues = mobile ? qa('[data-dlnv-vue]', mobile) : [];
  var mobileOuvert = false;

  function montrerVue(cle) {
    vues.forEach(function (v) { v.hidden = v.getAttribute('data-dlnv-vue') !== cle; });
    var courante = vues.filter(function (v) { return !v.hidden; })[0];
    var principale = cle === 'principale';
    if (retour) retour.hidden = principale;
    if (titre) titre.textContent = principale ? 'Menu' : (courante ? courante.getAttribute('data-dlnv-vue-titre') || 'Menu' : 'Menu');
    // un seul accordéon ouvert à la fois : tout replier à l'entrée d'une vue
    if (courante) qa('[data-dlnv-accordeon]', courante).forEach(function (t) { replier(t); });
    var corps = q('.dlnv-panneau__corps', mobile);
    if (corps) corps.scrollTop = 0;
  }
  function ouvrirMobile() {
    if (!mobile) return;
    mobileOuvert = true;
    mobile.hidden = false;
    html.classList.add('dlnv-verrou');
    burger.setAttribute('aria-expanded', 'true');
    montrerVue('principale');
    window.setTimeout(function () { if (panneau) panneau.focus(); }, 0);
  }
  function fermerMobile() {
    if (!mobile || !mobileOuvert) return;
    mobileOuvert = false;
    mobile.hidden = true;
    html.classList.remove('dlnv-verrou');
    burger.setAttribute('aria-expanded', 'false');
    if (burger && typeof burger.focus === 'function') burger.focus();
  }
  function replier(tete) {
    tete.setAttribute('aria-expanded', 'false');
    var liste = document.getElementById(tete.getAttribute('aria-controls'));
    if (liste) liste.hidden = true;
    var signe = q('.dlnv-accordeon__signe', tete);
    if (signe) signe.textContent = '+';
  }
  function deplier(tete) {
    var vue = tete.closest('[data-dlnv-vue]');
    qa('[data-dlnv-accordeon]', vue || mobile).forEach(function (t) { if (t !== tete) replier(t); });
    tete.setAttribute('aria-expanded', 'true');
    var liste = document.getElementById(tete.getAttribute('aria-controls'));
    if (liste) liste.hidden = false;
    var signe = q('.dlnv-accordeon__signe', tete);
    if (signe) signe.textContent = '−';
  }

  if (burger && mobile) {
    burger.addEventListener('click', function () { if (mobileOuvert) fermerMobile(); else ouvrirMobile(); });
    qa('[data-dlnv-fermer-mobile]', mobile).forEach(function (b) { b.addEventListener('click', fermerMobile); });
    qa('[data-dlnv-aller]', mobile).forEach(function (b) {
      b.addEventListener('click', function () {
        montrerVue(b.getAttribute('data-dlnv-aller'));
        if (retour) retour.focus();
      });
    });
    if (retour) retour.addEventListener('click', function () {
      montrerVue('principale');
      var premier = q('[data-dlnv-vue="principale"] button, [data-dlnv-vue="principale"] a', mobile);
      if (premier) premier.focus();
    });
    qa('[data-dlnv-accordeon]', mobile).forEach(function (t) {
      t.addEventListener('click', function () {
        if (t.getAttribute('aria-expanded') === 'true') replier(t); else deplier(t);
      });
    });
    // piège de focus léger : Tab reste dans le panneau
    panneau.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusables = qa('a[href], button:not([hidden]), [tabindex]:not([tabindex="-1"])', panneau).filter(function (el) { return el.offsetParent !== null && !el.hidden; });
      if (!focusables.length) return;
      var premier = focusables[0], dernier = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
      else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
    });
    qa('a', mobile).forEach(function (a) { a.addEventListener('click', function () { fermerMobile(); }); });
    window.addEventListener('resize', function () { if (mobileOuvert && window.innerWidth >= 990) fermerMobile(); });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    if (ouvert) { fermerVolets(true); return; }
    if (mobileOuvert) fermerMobile();
  });
  window.addEventListener('pagehide', function () { fermerVolets(false); });

  // Bandeau « Faites le quiz » : un clic mesuré, sans donnée personnelle. Sur la
  // page du questionnaire, le lien recharge la page et la session en cours est
  // reprise depuis le stockage local ; il ne relance ni n'efface rien.
  var bandeau = q('[data-dlnv-bandeau-quiz]');
  if (bandeau) bandeau.addEventListener('click', function () {
    try {
      var porteur = document.querySelector('[data-api]');
      var api = (porteur && porteur.getAttribute('data-api')) || 'https://api.dailylama.shop/v1';
      fetch(api + '/events', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: 'quiz_pierre_cta_click', props: { cta_position: 'bandeau', source_url: location.pathname } }), keepalive: true, mode: 'cors' }).catch(function () {});
    } catch (e) { /* mesure seulement */ }
  });
})();
